import ShowcaseDesc from "./DescriptionShowcase";
import ShowcaseImage from "./ImageShowcase";
import ShowcaseGallery from "./GalleryShowcase";

function SoftwareSectionFallback() {
    return (
        <>
        <ShowcaseImage 
            Title='My Portfolio Website' 
            Date="August 5, 2025 - Present"
            ImgURL='/PortfolioWebsite.png'
            ImgAlt='My portfolio Website Homepage'
        >
            <p>
                This is the current portfolio website you are looking at right now!
                I created this website with node.js using the react.js framework.
                My old website was styled after a terminal, but this website is styled
                in a more modern way.
            </p>
            <p>
                This website uses the react.js framework for the front end.
            </p>
            <p>
                With React.js, I was able to make the Expandable Dropdowns used to
                keep all my projects layed out nice and tidy.
            </p>
            <p>
                *Screenshot depicts a version of the website while in Development
            </p>
            <code>
                This Project Uses Javascript, HTML, CSS, React.js, Node.js, and AWS
            </code>
        </ShowcaseImage>
        <hr/>
        <ShowcaseDesc 
            Title="Discord DeepSeek Chat Bot" 
            Date="June 2025" 
            ButtonURL='https://github.com/BrianTheDevGuy/DiscordJSDeepseekBot'
            ButtonText='View on Github'
        >
            <p>
                A discord bot that uses a locally hosted deepseekv1-7b to respond to a discord user.
            </p>
            <p>
                This project uses discord.js to connect to the Discord API
                that allows a developer to create a discord bot.
                This in combination to deepseek being locally hosted with
                Ollama, I was able to create a configurable discord bot
                that can be either a bot assistant, or create a chat bot with
                a specified personality.
            </p>
            <p>
                You can view this project on my &nbsp;
                <a href='https://github.com/BrianTheDevGuy/DiscordJSDeepseekBot'>GitHub</a>&nbsp;
                Under&nbsp;
                <a href='https://github.com/BrianTheDevGuy/DiscordJSDeepseekBot'>DiscordJSDeepseekBot</a>
            </p>
            <code>
                This Project Uses Javascript, deepseekv1-7b trained model, and discord.js
            </code>
        </ShowcaseDesc>
        <hr/>
        <ShowcaseImage 
            Title='Radiant Threads' 
            Date="May 2025"
            ImgURL='/RadiantThreadsHome.jpg'
            ImgAlt='Radiant Threads Homepage'
            ImageOnLeft={true}
        >
            <p>
                This is a group project I worked on with 3 other people.
                I was in charge of creating the payment page, the about page,
                and the Thank You Page.
            </p>
            <p>
                I also helped the others with troubleshooting & debugging.
                For example, there was a bug that stopped the page from loading
                the next page when you tried navigating away from the home screen,
                but I was able to fix it.
            </p>
            <code>
                This Project Uses Javascript, HTML, CSS, React.js, Node.js and railway
            </code>
        </ShowcaseImage>
        <hr/>
        <ShowcaseGallery
            Title='E-business Website for Sweet Scent'
            Date='August 2022 - May 2023'
            ImgURLs={[
                '/SweetScentProducts/PumpkinPie.jpg', 
                '/SweetScentProducts/NPF2.jpg',
                '/SweetScentProducts/Sental.jpg',
                '/SweetScentProducts/MontanaForest.jpg',
                '/SweetScentProducts/DragonCandle.jpg',
                '/SweetScentProducts/IncenseSticks.jpg',
                '/SweetScentProducts/StarterKitBlack.jpg',
                '/SweetScentProducts/StarterKitFrost.jpg'
            ]}
            ImgAlts={[
                'Pumpkin Pie Candle', 
                'Flor De La Muerte Candle',
                'Sental Candle',
                'Montana Forest Candle',
                'Dragon Candle',
                'Incense Sticks',
                'Starter Kit Black',
                'Starter Kit Frost'
            ]}
        >
            <p>
                This was a website I built during high school for an Extracurricular
                program called e-business. I worked at a student made company called&nbsp;
                <em>Sweet Scent</em> where we would sell candles.
                I was in the digital media department as an associate where I worked with a <abbr title='Vice President'>VP</abbr> and
                2 other associates.
            </p>
            <p>
                My main job was to create the Company website for Sweet Scent.
                I used a website builder called <em>Wix</em> to create the website.
                I worked on the layout, design, & the functionality of the website.
            </p>
            <p>
                For example, I designed the general layout and looks of the website
                with help of the art & publications department.
                I also placed products into the website database using
                the products created by the sales department.
                Additionally, I worked on the filtering & sorting
                and image editing of the product selection.
                and finally, I also translated the website to Spanish for
                non-English Speakers.
            </p>
            <p>You can see a few products from Sweet Scent on the right ----&gt;</p>
            <code>
                This Project Uses Wix (a website builder)
            </code>
        </ShowcaseGallery>
        </>
    );
}

export default SoftwareSectionFallback;